
import type { CartItem } from "@/context/CartContext";
import { CartPriceDetails } from "./CartPriceDetails";
import { OrderActions } from "./OrderActions";
import { CGVDialog } from "./CGVDialog";

interface CartSummaryProps {
  items: CartItem[];
  isSubmitting: boolean;
  showConfirmation: boolean;
  user: any;
  onInitiateOrder: () => void;
  onConfirmOrder: () => void;
  onCancelOrder: () => void;
  onLogin: () => void;
}

export const CartSummary = ({
  items,
  isSubmitting,
  showConfirmation,
  user,
  onInitiateOrder,
  onConfirmOrder,
  onCancelOrder,
  onLogin,
}: CartSummaryProps) => {
  // Calculate total for OrderActions component
  const calculateSubtotal = (cartItems: CartItem[]) => {
    return cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  };
  
  const subtotal = calculateSubtotal(items);
  const tps = subtotal * 0.05;
  const tvq = subtotal * 0.09975;
  const total = subtotal + tps + tvq;

  return (
    <div className="p-4 sm:p-6">
      <h2 className="font-medium text-base sm:text-lg text-zinc-900 mb-3 sm:mb-6">Résumé de la commande</h2>
      
      <CartPriceDetails items={items} />
      
      <OrderActions
        isSubmitting={isSubmitting}
        showConfirmation={showConfirmation}
        user={user}
        isCartEmpty={items.length === 0}
        total={total}
        onInitiateOrder={onInitiateOrder}
        onConfirmOrder={onConfirmOrder}
        onCancelOrder={onCancelOrder}
        onLogin={onLogin}
      />
    </div>
  );
};
